import Valkyrie from "@sippy-platform/valkyrie";

import { Box, Stack, Typography, useTheme } from "@mui/material";
import PropTypes from "prop-types";

export default function FeatureBlock({ icon, title, description }) {
  const theme = useTheme();

  return (
    <Stack
      sx={{
        gap: 0.5,
      }}
    >
      <Box
        sx={{
          backgroundColor: (theme) => `color-mix(in srgb, ${theme.vars.palette.primary[500]} 20%, transparent)`,
          borderRadius: 1,
          contain: "paint",
          width: 48,
          height: 48,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Valkyrie icon={icon} style={{ fontSize: 24, color: theme.vars.palette.primary[500] }} />
      </Box>
      <Typography variant="h5" sx={{ fontSize: 22, m: 0, mb: 0.5, mt: 1 }}>
        {title}
      </Typography>
      <Typography>{description}</Typography>
    </Stack>
  );
}

FeatureBlock.propTypes = {
  icon: PropTypes.object,
  title: PropTypes.string,
  description: PropTypes.string,
};
